import { MenuProps } from 'antd'
import { RichPromotionPage } from 'components/goods/RichPromotion/RichPromotionPage'
import {
  ApiOutlined,
  AppstoreAddOutlined,
  CarOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  GlobalOutlined,
  IdcardOutlined,
  ImportOutlined,
  LineChartOutlined,
  LinkOutlined,
  LogoutOutlined,
  MessageOutlined,
  NotificationOutlined,
  PercentageOutlined,
  SettingOutlined,
  ShoppingOutlined,
  StarOutlined,
  StockOutlined,
  TagOutlined,
  TeamOutlined
} from '@ant-design/icons'
import { Navigate, createBrowserRouter } from 'react-router-dom'
import { UsersList } from 'pages/superAdmin/Users/List/List'
import { SellersList } from 'pages/superAdmin/Sellers/List/List'
import { AddUser } from 'pages/superAdmin/Users/Add/Add'
import { EditUser } from 'pages/superAdmin/Users/Edit/Edit'
import { GoodsEdit } from 'pages/superAdmin/Goods/Edit/Edit'
import { AppWrapper } from 'components/layout/AppWrapper/AppWrapper'
import { superAdminRoutes } from 'shared/constants/routes'
import { AddSeller } from 'pages/superAdmin/Sellers/Add/Add'
import { SellerWrapper } from 'components/sellers/SellerWrapper/SellerWrapper'
import { SellerInfo } from 'pages/superAdmin/Sellers/Edit/Info/Info'
import { SellerSettings } from 'pages/superAdmin/Sellers/Edit/Settings/Settings'
import { SellerGoods } from 'pages/superAdmin/Sellers/Edit/Goods/Goods'
import { SellerOrders } from 'pages/superAdmin/Sellers/Edit/Orders/Orders'
import { SellerShops } from 'pages/superAdmin/Sellers/Edit/Shops/Shops'
import { SellerDelivery } from 'pages/superAdmin/Sellers/Edit/Delivery/Delivery'
import { SellerAccounting } from 'pages/superAdmin/Sellers/Edit/Accounting/Accounting'
import { SellerApiMoySklad } from 'pages/superAdmin/Sellers/Edit/ApiMoySklad/ApiMoySklad'
import { SellerApiOneC } from 'pages/superAdmin/Sellers/Edit/ApiOneC/ApiOneC'
import { SellerApiInsales } from 'pages/superAdmin/Sellers/Edit/ApiInsales/ApiInsales'
import { SellerNotifications } from 'pages/superAdmin/Sellers/Edit/Notifications/Notifications'
import { SellerEmployees } from 'pages/superAdmin/Sellers/Edit/Employees/Employees'
import { SuperOrder } from 'pages/superAdmin/SuperOrder/SuperOrder'
import { Categories } from 'pages/superAdmin/Categories/Categories'
import { GoodsList } from 'pages/superAdmin/Goods/List/GoodsList'
import { OrdersList } from 'pages/superAdmin/Orders/List/OrdersList'
import { OrderEdit } from 'pages/superAdmin/Orders/Edit/OrderEdit'
import { ActionsNotifications } from 'pages/superAdmin/Actions/Notifications/Notifications'
import { WithdrawalRequests } from 'pages/superAdmin/Actions/WithdrawalRequests/WithdrawalRequests'
import { Reviews } from 'pages/superAdmin/Actions/Reviews/Reviews'
import { PendingReviewsBadge } from 'components/reviews/PendingReviewsBadge/PendingReviewsBadge'
import { PendingWithdrawalRequestsBadge } from 'components/actions/PendingWithdrawalRequestsBadge/PendingWithdrawalRequestsBadge'
import { ActionsLogistics } from 'pages/superAdmin/Actions/Logistics/Logistics'
import { ActionsEmployees } from 'pages/superAdmin/Actions/Employees/Employees'
import { ActionsFeeds } from 'pages/superAdmin/Actions/Feeds/Feeds'
import { ActionsAdLinks } from 'pages/superAdmin/Actions/AdLinks/AdLinks'
import { ActionsAnalytics } from 'pages/superAdmin/Actions/Analytics/Analytics'
import {
  ActionsWrapper,
  LOGOUT_MENU_KEY
} from 'components/actions/ActionsWrapper/ActionsWrapper'
import { Horses } from 'pages/superAdmin/Horses/Horses'
import { Horse } from 'pages/superAdmin/Horses/Horse'
import { CollectionEdit } from 'pages/superAdmin/Collections/CollectionEdit'
import { AiGoodsList } from 'pages/superAdmin/AiGoods/List/AiGoodsList'
import { AiGoodsCreate } from 'pages/superAdmin/AiGoods/Create/AiGoodsCreate'
import { AiGoodsEdit } from 'pages/superAdmin/AiGoods/Edit/AiGoodsEdit'
import { SellerAiGoods } from 'pages/superAdmin/Sellers/Edit/AiGoods/AiGoods'
import { SeoPages } from 'pages/superAdmin/SeoPages'
import { PromoCodesList } from 'pages/superAdmin/PromoCodes/List/PromoCodesList'
import { PromoCodesCreate } from 'pages/superAdmin/PromoCodes/Create/PromoCodesCreate'
import { SellerPromoCodes } from 'pages/superAdmin/Sellers/Edit/PromoCodes/PromoCodes'
import { SellerDiscounts } from 'pages/superAdmin/Sellers/Edit/Discounts/Discounts'
import { SellerReviews } from 'pages/superAdmin/Sellers/Edit/Reviews/Reviews'
import { SellerMassImport } from 'pages/superAdmin/Sellers/Edit/MassImport/MassImport'
import { PromoCodesEdit } from 'pages/superAdmin/PromoCodes/Edit/PromoCodesEdit'
import { DiscountsList } from 'pages/superAdmin/Discounts/List/DiscountsList'
import { DiscountsCreate } from 'pages/superAdmin/Discounts/Create/DiscountsCreate'
import { DiscountsEdit } from 'pages/superAdmin/Discounts/Edit/DiscountsEdit'
import { Main } from 'pages/superAdmin/Main/Main'
import { PoloClub } from 'pages/superAdmin/PoloClub/PoloClub'
import { CreateService } from 'pages/superAdmin/PoloClub/CreateService'
import { SellerChats } from 'pages/superAdmin/Sellers/Edit/Chats/Chats'
import { Support } from 'pages/superAdmin/Support/Support'

const sellerLinks: MenuProps['items'] = [
  {
    label: 'Настройки продавца',
    key: superAdminRoutes.SELLER_SETTINGS,
    icon: <SettingOutlined />
  },
  {
    label: 'Основная информация',
    key: superAdminRoutes.SELLER_INFO,
    icon: <IdcardOutlined />
  },
  {
    label: 'Сообщения',
    key: superAdminRoutes.SELLER_CHATS,
    icon: <MessageOutlined />
  },
  {
    label: 'Товары',
    key: superAdminRoutes.SELLER_GOODS,
    icon: <AppstoreAddOutlined />
  },
  {
    label: 'Заказы',
    key: superAdminRoutes.SELLER_ORDERS,
    icon: <ShoppingOutlined />
  },
  {
    label: 'Адреса магазинов',
    key: superAdminRoutes.SELLER_SHOPS,
    icon: <EnvironmentOutlined />
  },
  {
    label: 'Способы доставки',
    key: superAdminRoutes.SELLER_DELIVERY,
    icon: <CarOutlined />
  },
  {
    label: 'Бухгалтерия',
    key: superAdminRoutes.SELLER_ACCOUNTING,
    icon: <StockOutlined />
  },
  {
    label: 'Сотрудники',
    key: superAdminRoutes.SELLER_EMPLOYEES,
    icon: <TeamOutlined />
  },
  {
    label: 'Уведомления',
    key: superAdminRoutes.SELLER_NOTIFICATIONS,
    icon: <NotificationOutlined />
  },
  {
    label: 'Массовый импорт',
    key: superAdminRoutes.SELLER_MASS_IMPORT,
    icon: <ImportOutlined />
  },
  {
    label: 'API Синхронизация',
    key: 'api',
    icon: <ApiOutlined />,
    children: [
      {
        label: '1С Синхронизация',
        key: superAdminRoutes.SELLER_API_ONE_C
      },
      {
        label: 'Мой склад',
        key: superAdminRoutes.SELLER_API_MOYSKLAD
      },
      {
        label: 'InSales',
        key: superAdminRoutes.SELLER_API_INSALES
      }
    ]
  },
  {
    label: 'Промокоды',
    key: superAdminRoutes.SELLER_PROMOCODES,
    icon: <TagOutlined />
  },
  {
    label: 'Скидки',
    key: superAdminRoutes.SELLER_DISCOUNTS,
    icon: <PercentageOutlined />
  },
  {
    label: 'Отзывы',
    key: superAdminRoutes.SELLER_REVIEWS,
    icon: <StarOutlined />
  }
]

const actionsLinks: MenuProps['items'] = [
  {
    label: 'Сквозная аналитика',
    key: superAdminRoutes.ACTIONS_ANALYTICS,
    icon: <LineChartOutlined />
  },
  {
    label: 'Глобальное уведомление',
    key: superAdminRoutes.ACTIONS_NOTIFICATIONS,
    icon: <GlobalOutlined />
  },
  {
    label: (
      <PendingWithdrawalRequestsBadge>Заявки на вывод</PendingWithdrawalRequestsBadge>
    ),
    key: superAdminRoutes.ACTIONS_WITHDRAWAL_REQUESTS,
    icon: <DollarOutlined />
  },
  {
    label: <PendingReviewsBadge>Отзывы</PendingReviewsBadge>,
    key: superAdminRoutes.ACTIONS_REVIEWS,
    icon: <StarOutlined />
  },
  {
    label: 'Логистика',
    key: superAdminRoutes.ACTIONS_LOGISTICS,
    icon: <CarOutlined />
  },
  {
    label: 'Администраторы',
    key: superAdminRoutes.ACTIONS_EMPLOYEES,
    icon: <TeamOutlined />
  },
  {
    label: 'Настройки',
    key: superAdminRoutes.ACTIONS_SETTINGS,
    icon: <SettingOutlined />
  },
  {
    label: 'Фиды',
    key: superAdminRoutes.ACTIONS_FEEDS,
    icon: <FileTextOutlined />
  },
  {
    label: 'Рекламные ссылки',
    key: superAdminRoutes.ACTIONS_AD_LINKS,
    icon: <LinkOutlined />
  },
  {
    label: 'Выйти',
    key: LOGOUT_MENU_KEY,
    icon: <LogoutOutlined />
  }
]

export const superAdminRouter = createBrowserRouter([
  {
    path: '/',
    element: <AppWrapper />,
    children: [
      {
        // стартовый раздел — заказы: с них начинают работу и продавец, и админ
        index: true,
        element: <Navigate to={superAdminRoutes.ORDERS} />
      },
      {
        path: superAdminRoutes.USERS,
        element: <UsersList />
      },
      {
        path: superAdminRoutes.USERS_ADD,
        element: <AddUser />
      },
      {
        path: superAdminRoutes.USERS_EDIT,
        element: <EditUser />
      },
      {
        path: superAdminRoutes.SELLERS,
        element: <SellersList />
      },
      {
        path: superAdminRoutes.SELLERS_ADD,
        element: <AddSeller />
      },
      {
        path: superAdminRoutes.SUPPORT,
        element: <Support />
      },
      {
        path: superAdminRoutes.SELLER,
        element: (
          <SellerWrapper
            type='seller'
            links={sellerLinks}
            autoCollapseKeys={[
              superAdminRoutes.SELLER_GOODS,
              superAdminRoutes.SELLER_PROMOCODES,
              superAdminRoutes.SELLER_DISCOUNTS,
              superAdminRoutes.SELLER_CHATS
            ]}
          />
        ),
        children: [
          {
            index: true,
            element: <SellerInfo />
          },
          {
            path: superAdminRoutes.SELLER_SETTINGS,
            element: <SellerSettings />
          },
          {
            path: superAdminRoutes.SELLER_GOODS,
            element: <SellerGoods />
          },
          {
            path: superAdminRoutes.SELLER_ORDERS,
            element: <SellerOrders />
          },
          {
            path: superAdminRoutes.SELLER_SHOPS,
            element: <SellerShops />
          },
          {
            path: superAdminRoutes.SELLER_DELIVERY,
            element: <SellerDelivery />
          },
          {
            path: superAdminRoutes.SELLER_ACCOUNTING,
            element: <SellerAccounting />
          },
          {
            path: superAdminRoutes.SELLER_EMPLOYEES,
            element: <SellerEmployees />
          },
          {
            path: superAdminRoutes.SELLER_MASS_IMPORT,
            element: <SellerMassImport />
          },
          {
            path: superAdminRoutes.SELLER_API_ONE_C,
            element: <SellerApiOneC />
          },
          {
            path: superAdminRoutes.SELLER_API_MOYSKLAD,
            element: <SellerApiMoySklad />
          },
          {
            path: superAdminRoutes.SELLER_API_INSALES,
            element: <SellerApiInsales />
          },
          {
            path: superAdminRoutes.SELLER_NOTIFICATIONS,
            element: <SellerNotifications />
          },
          {
            path: superAdminRoutes.SELLER_AI_GOODS,
            element: <SellerAiGoods />
          },
          {
            path: superAdminRoutes.SELLER_PROMOCODES,
            element: <SellerPromoCodes />
          },
          {
            path: superAdminRoutes.SELLER_DISCOUNTS,
            element: <SellerDiscounts />
          },
          {
            path: superAdminRoutes.SELLER_REVIEWS,
            element: <SellerReviews />
          },
          {
            path: superAdminRoutes.SELLER_CHATS,
            element: <SellerChats />
          }
        ]
      },
      {
        path: superAdminRoutes.ORDERS,
        element: <OrdersList />
      },
      {
        path: superAdminRoutes.ORDER,
        element: <OrderEdit />
      },
      {
        path: superAdminRoutes.SUPER_ORDER,
        element: <SuperOrder />
      },
      {
        path: superAdminRoutes.GOODS,
        element: <GoodsList />
      },
      {
        path: superAdminRoutes.GOODS_EDIT,
        element: <GoodsEdit />
      },
      { path: '/goods/edit/:id/promotion', element: <RichPromotionPage /> },
      {
        path: superAdminRoutes.CATEGORIES,
        element: <Categories />
      },
      {
        path: superAdminRoutes.HORSES,
        element: <Horses />
      },
      {
        path: superAdminRoutes.HORSE,
        element: <Horse />
      },
      {
        path: superAdminRoutes.ACTIONS,
        element: <ActionsWrapper links={actionsLinks} />,
        children: [
          {
            index: true,
            element: <Navigate to={superAdminRoutes.ACTIONS_ANALYTICS} />
          },
          {
            path: superAdminRoutes.ACTIONS_NOTIFICATIONS,
            element: <ActionsNotifications />
          },
          {
            path: superAdminRoutes.ACTIONS_WITHDRAWAL_REQUESTS,
            element: <WithdrawalRequests />
          },
          {
            path: superAdminRoutes.ACTIONS_REVIEWS,
            element: <Reviews />
          },
          {
            path: superAdminRoutes.ACTIONS_LOGISTICS,
            element: <ActionsLogistics />
          },
          {
            path: superAdminRoutes.ACTIONS_EMPLOYEES,
            element: <ActionsEmployees />
          },
          {
            path: superAdminRoutes.ACTIONS_SETTINGS,
            element: <SeoPages />
          },
          {
            // SeoPages маршрутизирует себя сам, поэтому нужен путь со звёздочкой
            path: `${superAdminRoutes.ACTIONS_SETTINGS}/*`,
            element: <SeoPages />
          },
          {
            path: superAdminRoutes.ACTIONS_FEEDS,
            element: <ActionsFeeds />
          },
          {
            path: superAdminRoutes.ACTIONS_AD_LINKS,
            element: <ActionsAdLinks />
          },
          {
            path: superAdminRoutes.ACTIONS_ANALYTICS,
            element: <ActionsAnalytics />
          }
        ]
      },
      {
        path: superAdminRoutes.COLLECTIONS,
        element: <Navigate to={superAdminRoutes.MAIN} />
      },
      {
        path: superAdminRoutes.COLLECTIONS_EDIT,
        element: <CollectionEdit />
      },
      {
        path: superAdminRoutes.AI_GOODS,
        element: <AiGoodsList />
      },
      {
        path: superAdminRoutes.AI_GOODS_CREATE,
        element: <AiGoodsCreate />
      },
      {
        path: superAdminRoutes.AI_GOODS_EDIT,
        element: <AiGoodsEdit />
      },
      {
        path: superAdminRoutes.SETTINGS,
        element: (
          <Navigate
            to={`${superAdminRoutes.ACTIONS}/${superAdminRoutes.ACTIONS_SETTINGS}`}
            replace
          />
        )
      },
      {
        path: `${superAdminRoutes.SETTINGS}/*`,
        element: (
          <Navigate
            to={`${superAdminRoutes.ACTIONS}/${superAdminRoutes.ACTIONS_SETTINGS}`}
            replace
          />
        )
      },
      {
        path: superAdminRoutes.SEO_PAGES,
        element: <SeoPages />
      },
      {
        path: `${superAdminRoutes.SEO_PAGES}/*`,
        element: <SeoPages />
      },
      {
        path: superAdminRoutes.PROMOCODES,
        element: <PromoCodesList />
      },
      {
        path: superAdminRoutes.PROMOCODES_CREATE,
        element: <PromoCodesCreate />
      },
      {
        path: superAdminRoutes.PROMOCODES_EDIT,
        element: <PromoCodesEdit />
      },
      {
        path: superAdminRoutes.DISCOUNTS,
        element: <DiscountsList />
      },
      {
        path: superAdminRoutes.DISCOUNTS_CREATE,
        element: <DiscountsCreate />
      },
      {
        path: superAdminRoutes.DISCOUNTS_EDIT,
        element: <DiscountsEdit />
      },
      {
        path: superAdminRoutes.BANNERS,
        element: <Navigate to={superAdminRoutes.MAIN} />
      },
      {
        path: superAdminRoutes.MAIN,
        element: <Main />
      },
      {
        path: superAdminRoutes.POLO_CLUB,
        element: <PoloClub />
      },
      {
        path: superAdminRoutes.POLO_CLUB_SERVICE_CREATE,
        element: <CreateService />
      },
      {
        path: superAdminRoutes.POLO_CLUB_SERVICE_EDIT,
        element: <CreateService />
      },
      {
        path: superAdminRoutes.FEED_SETTINGS,
        element: <Navigate to={superAdminRoutes.MAIN} />
      },
      {
        path: '*',
        element: <Navigate to='/' />
      }
    ]
  }
])
